module.exports = __webpack_public_path__ + "img/photo_2023-11-22 13.51.32.d2220b6c.jpg";